var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF0000",
    d: "M23.498 6.186c-.272-1.023-1.074-1.827-2.097-2.1C19.72 3.5 12 3.5 12 3.5s-7.72 0-9.401.586c-1.023.273-1.825 1.077-2.097 2.1C0 7.874 0 12 0 12s0 4.126.502 5.814c.272 1.023 1.074 1.827 2.097 2.1C4.28 20.5 12 20.5 12 20.5s7.72 0 9.401-.586c1.023-.273 1.825-1.077 2.097-2.1.502-1.688.502-5.814.502-5.814s0-4.126-.502-5.814z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9.75 8.75v6.5L15.5 12l-5.75-3.25z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeFilled);
export default __webpack_public_path__ + "static/media/youtubeFilled.560ec8df2e247891ade40f0328988bdf.svg";
export { ForwardRef as ReactComponent };